import React from "react";

/** Шапка страницы секции настроек: заголовок и одна строка о том, что здесь
 *  настраивается. Девять страниц секций не копируют разметку — иначе они
 *  разъезжались бы по размеру и отступам при первой же правке одной из них. */
export function SettingsPageHeader({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}): React.ReactElement {
  return (
    <div>
      <h1 className="text-2xl font-bold">{title}</h1>
      <p className="text-sm text-muted-foreground">{subtitle}</p>
    </div>
  );
}
